import React from 'react';
import { toast } from 'react-toastify';
import { API } from 'aws-amplify';

import reducer from './reducer';

const useRecordChanges = (AppInstID) => {
    const [changes, dispatch] = React.useReducer(reducer, { AppInstID });

    const markResolved = async () => {
        let id = toast.loading('Marking resolved...');

        try {
            await API.post('ShipyardAPI', `/admin/application_instance/${changes.AppInstID}/resolve_change`);

            toast.success('Changes marked as resolved.');

            dispatch({ type: 'resolve' });
        } catch (e) {
            toast.error('General.AjaxError');
        } finally {
            toast.dismiss(id);
        }
    };

    const getRecordChanges = async (TermID) => {
        try {
            let _changes = await API.get('ShipyardAPI', `/admin/application_instance/${changes.AppInstID}`, {
                queryStringParameters: {
                    TermID: TermID,
                },
            });

            if (!!_changes) {
                dispatch({ type: 'patch', changes: _changes });
            } else {
                dispatch({ type: 'dismiss' });
            }
        } catch (e) {
            throw new Error('RecordChanges', { cause: e });
        }
    };

    return [changes, getRecordChanges, markResolved];
};

export default useRecordChanges;
